import MeetingRequest from "./MeetingRequestForm/MeetingRequest";
import MeetingNavbar from "./MeetingRequestForm/MeetingNavbar";


const MeetingRequestFormWrapper = () => {
  return (
    <div
      className="min-h-screen bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/bg.png')" }}
    >
      <MeetingNavbar />
      <MeetingRequest />
    </div>
  );
};

export default MeetingRequestFormWrapper;
